export const setSelectedMenu = id => ({ type: "SET_SELECTED_MENU", id });
export const setNote = note => ({ type: "SET_NOTE", note });
